import { render, staticRenderFns } from "./purchaseRecordList.vue?vue&type=template&id=0c69bbe3&scoped=true&"
import script from "./purchaseRecordList.vue?vue&type=script&lang=js&"
export * from "./purchaseRecordList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRecordList.vue?vue&type=style&index=0&id=0c69bbe3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69bbe3",
  null
  
)

export default component.exports